var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391 512V511.062C450.113 503.66 496 453.09 496 392C496 336.188 457.699 289.152 406 275.797V30C398.758 30 284.777 30 256 30V0H166V30C137.223 30 23.4883 30 16 30V512H391ZM466 392C466 441.625 425.625 482 376 482C326.375 482 286 441.625 286 392C286 342.375 326.375 302 376 302C425.625 302 466 342.375 466 392ZM136 60H196V30H226V60H286V92H136V60ZM46 482V60H106V122H316V60H376V272C309.832 272 256 325.832 256 392C256 427.805 271.77 459.992 296.723 482H46Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 152H346V182H76V152Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 212H316V242H76V212Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 272H256V302H76V272Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 332H196V362H76V332Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.605 381.395L320.395 402.605L361 443.215L431.605 372.605L410.395 351.395L361 400.785L341.605 381.395Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup2);
export default __webpack_public_path__ + "static/media/signup_2.e240ea5670c2700cfb2ce5e7b0b45d57.svg";
export { ForwardRef as ReactComponent };